function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';

var SelectedGeneratorsCheckbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectedGeneratorsCheckbox, _React$Component);

  function SelectedGeneratorsCheckbox(props) {
    var _this;

    _classCallCheck(this, SelectedGeneratorsCheckbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectedGeneratorsCheckbox).call(this, props));
    _this._onCheckboxChange = _this._onCheckboxChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(SelectedGeneratorsCheckbox, [{
    key: "_onCheckboxChange",
    value: function _onCheckboxChange() {
      this.props.plotGeneratorSelected(this.props.generatorId, this.refs.checkbox.checked);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "cndc-checkbox-wrapper"
      }, React.createElement("label", {
        className: "checkbox-inline cndc-checkbox-label",
        htmlFor: this.props.checkboxId
      }, React.createElement("input", {
        type: "checkbox",
        className: "cndc-checkbox checkbox-replaced",
        id: this.props.checkboxId,
        name: this.props.checkboxId,
        checked: this.props.checkboxChecked,
        onChange: this._onCheckboxChange,
        ref: "checkbox"
      }), this.props.checkboxTitle, React.createElement("label", {
        className: "checkbox-replacement checkbox-replacement--colored",
        htmlFor: this.props.checkboxId,
        style: {
          backgroundColor: this.props.checkboxColor
        }
      })));
    }
  }]);

  return SelectedGeneratorsCheckbox;
}(React.Component);

SelectedGeneratorsCheckbox.propTypes = {
  plotId: PropTypes.string.isRequired,
  checkboxId: PropTypes.string.isRequired,
  generatorId: PropTypes.string.isRequired,
  checkboxChecked: PropTypes.bool.isRequired,
  checkboxTitle: PropTypes.string.isRequired,
  checkboxColor: PropTypes.string.isRequired,
  plotGeneratorSelected: PropTypes.func.isRequired
};
export { SelectedGeneratorsCheckbox as default };